window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-permissions-setting');
    if (!page) return;

    $(function () {
        init();

        function init() {
            controlDisplay();

            $("select[name='item_type']").on('change', function () {
                controlDisplay();
            });
        }

        function controlDisplay() {
            const itemType = $("select[name='item_type']").val();

            switch (itemType) {
                case 'screen':
                    $('div.item-access').show();
                    $('div.item-rules').hide();
                    break;
                default:
                    $('div.item-access').hide();
                    $('div.item-rules').show();
                    break;
            }
        }
    });
});
